import { Link } from "react-router-dom";
import { Shell } from "../components/Shell";

interface Guide {
  slug: string;
  titulo: string;
  resumen: string;
  emoji: string;
  audiencia: string;
  duracion: string;
}

interface Categoria {
  titulo: string;
  descripcion: string;
  guides: Guide[];
}

const CATEGORIAS: Categoria[] = [
  {
    titulo: "Operación de la plataforma",
    descripcion:
      "Guías para el equipo super_admin de MiPueblo. Onboarding de clientes, integraciones, operación técnica.",
    guides: [
      {
        slug: "onboarding",
        titulo: "Onboarding inicial de una alcaldía",
        resumen:
          "Crear el tenant, primer admin, branding, horarios, dependencias, KB, bot RAG y canales — todo lo necesario para que un municipio nuevo arranque.",
        emoji: "🚀",
        audiencia: "super_admin",
        duracion: "30-60 min",
      },
      {
        slug: "whatsapp",
        titulo: "WhatsApp Cloud API para alcaldías",
        resumen:
          "Crear Meta Business, verificar el NIT, conectar el número oficial y dejarlo integrado al chat ciudadano.",
        emoji: "💬",
        audiencia: "Equipo TIC + super_admin",
        duracion: "1-2 h + verificación Meta",
      },
      {
        slug: "proveedores-ia",
        titulo: "Configuración de proveedores IA",
        resumen:
          "Anthropic, OpenAI, Gemini, LM Studio, Ollama. Cuál elegir, cómo conseguir API keys, costos aproximados y rotación.",
        emoji: "🔌",
        audiencia: "super_admin",
        duracion: "15-30 min",
      },
      {
        slug: "runbook",
        titulo: "Runbook de operaciones",
        resumen:
          "Deploys, backups, restore, alembic, logs, incidentes comunes y rotación de secrets. Tu referencia para no improvisar a las 3 am.",
        emoji: "🛠",
        audiencia: "super_admin",
        duracion: "Lectura ~25 min",
      },
      {
        slug: "eliminar-tenant",
        titulo: "Eliminar o migrar un tenant",
        resumen:
          "Procedimiento compliance Ley 1581/2012 cuando una alcaldía cancela contrato — exportar, suspender, eliminar y migrar a otro proveedor.",
        emoji: "🗑",
        audiencia: "super_admin",
        duracion: "30 min + periodo de gracia 30 días",
      },
    ],
  },
  {
    titulo: "Módulos funcionales",
    descripcion:
      "Documentación de los módulos del producto orientada a la operación diaria: cómo funciona cada uno, flujos completos y buenas prácticas.",
    guides: [
      {
        slug: "pqrsdf",
        titulo: "PQRSDF (derecho de petición)",
        resumen:
          "Los 6 tipos de PQRSDF, plazos legales por subtipo (Ley 1755/2015), flujo público, bandeja, respuesta con IA-draft, firma PAdES, SLA, tutela y reportes.",
        emoji: "🗳",
        audiencia: "admin_tenant + funcionarios",
        duracion: "Lectura ~25 min",
      },
      {
        slug: "radicacion",
        titulo: "Radicación de correspondencia oficial",
        resumen:
          "Correspondencia institucional (Ley 594/2000): numeración, entrante/saliente/interna, anexos, foliación PDF/A, transferencia al archivo central.",
        emoji: "📥",
        audiencia: "archivo + ventanilla",
        duracion: "Lectura ~25 min",
      },
      {
        slug: "citas",
        titulo: "Citas de atención",
        resumen:
          "Agendamiento de citas presenciales del ciudadano, disponibilidad por dependencia, recordatorios, cancelación y reprogramación.",
        emoji: "📅",
        audiencia: "admin_tenant + funcionario de turno",
        duracion: "Lectura ~15 min",
      },
      {
        slug: "gestion-documental",
        titulo: "Gestión Documental",
        resumen:
          "Expedientes, clasificación TRD, foliación, transferencias documentales, retención y disposición final. Incluye flujo con IA.",
        emoji: "📂",
        audiencia: "admin_tenant + archivo + funcionarios",
        duracion: "Lectura ~30 min",
      },
    ],
  },
  {
    titulo: "Manuales de uso",
    descripcion:
      "Para los usuarios que cada alcaldía designe. Los pasas como material de capacitación cuando entregas el tenant.",
    guides: [
      {
        slug: "admin-tenant",
        titulo: "Manual del administrador (admin_tenant)",
        resumen:
          "Funcionarios, dependencias, plantillas, KB, horarios, permisos, SLA, encuestas, métricas, auditoría y habeas data.",
        emoji: "📘",
        audiencia: "admin_tenant",
        duracion: "Lectura ~30 min",
      },
      {
        slug: "operador",
        titulo: "Manual del operador / funcionario",
        resumen:
          "Atender chat ciudadano, responder PQRSDFs con IA, plantillas, firma digital, plazos Ley 1755, buenas prácticas.",
        emoji: "📗",
        audiencia: "operador",
        duracion: "Lectura ~20 min",
      },
      {
        slug: "supervisor",
        titulo: "Manual del supervisor",
        resumen:
          "Monitorear equipo, reasignar PQRSDFs, alertas SLA, métricas por funcionario, lectura de encuestas, reportes.",
        emoji: "📙",
        audiencia: "supervisor",
        duracion: "Lectura ~20 min",
      },
    ],
  },
  {
    titulo: "Legal y compliance",
    descripcion:
      "Plantillas legales basadas en la normativa colombiana. Cada alcaldía debe revisarlas con su jurídica antes de publicar.",
    guides: [
      {
        slug: "habeas-data",
        titulo: "Política de privacidad y Habeas Data",
        resumen:
          "Plantilla conforme Ley 1581/2012 y Decreto 1377/2013. Va pública al pie del portal del tenant.",
        emoji: "⚖️",
        audiencia: "admin_tenant + jurídica",
        duracion: "Revisión jurídica ~1 h",
      },
      {
        slug: "terminos",
        titulo: "Términos de uso",
        resumen:
          "Plantilla de términos para el portal ciudadano. Define uso permitido, SLA, propiedad intelectual, jurisdicción.",
        emoji: "📜",
        audiencia: "admin_tenant + jurídica",
        duracion: "Revisión jurídica ~30 min",
      },
      {
        slug: "retencion",
        titulo: "Política de retención de datos",
        resumen:
          "Cuánto se guarda qué (PQRSDF 10 años, chats 2 años, logs 30 días...). Cron de purga + reporte anual a SIC.",
        emoji: "🔒",
        audiencia: "admin_tenant + archivo",
        duracion: "Lectura ~15 min",
      },
    ],
  },
];

export function DocsPage() {
  return (
    <Shell>
      <section className="page" style={{ maxWidth: 1100 }}>
        <div className="eyebrow">Recursos · Documentación</div>
        <h1 style={{ margin: "8px 0 6px" }}>Documentación</h1>
        <p className="lede" style={{ maxWidth: 640 }}>
          Guías paso a paso para onboardear alcaldías, manuales de uso por rol
          y plantillas legales según la normativa colombiana.
        </p>

        {CATEGORIAS.map((cat) => (
          <section key={cat.titulo} style={{ marginTop: 36 }}>
            <h2
              style={{
                fontSize: 18,
                margin: "0 0 4px",
                fontFamily: "var(--font-mono)",
                letterSpacing: "0.08em",
                textTransform: "uppercase",
                color: "var(--ink-2)",
              }}
            >
              {cat.titulo}
            </h2>
            <p
              style={{
                margin: "0 0 16px",
                fontSize: 13,
                color: "var(--ink-3)",
                maxWidth: 640,
              }}
            >
              {cat.descripcion}
            </p>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
                gap: 14,
              }}
            >
              {cat.guides.map((g) => (
                <Link
                  key={g.slug}
                  to={`/docs/${g.slug}`}
                  className="card"
                  style={{
                    display: "block",
                    textDecoration: "none",
                    color: "inherit",
                  }}
                >
                  <div className="card-inner" style={{ padding: 16 }}>
                    <div
                      style={{ fontSize: 24, marginBottom: 6 }}
                      aria-hidden
                    >
                      {g.emoji}
                    </div>
                    <h3
                      style={{
                        margin: "0 0 6px",
                        fontSize: 15,
                        lineHeight: 1.3,
                      }}
                    >
                      {g.titulo}
                    </h3>
                    <p
                      style={{
                        margin: "0 0 12px",
                        fontSize: 12.5,
                        color: "var(--ink-2)",
                        lineHeight: 1.5,
                      }}
                    >
                      {g.resumen}
                    </p>
                    <div
                      style={{
                        display: "grid",
                        gap: 3,
                        fontFamily: "var(--font-mono)",
                        fontSize: 10,
                        color: "var(--ink-3)",
                        letterSpacing: "0.04em",
                        borderTop: "1px solid var(--hairline)",
                        paddingTop: 8,
                      }}
                    >
                      <span>👥 {g.audiencia}</span>
                      <span>⏱ {g.duracion}</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </section>
        ))}
      </section>
    </Shell>
  );
}
